import withAsyncRouteLoading from "UIComponents/AsyncRouteLoadingHoc";
export default () => {
  return {
    path: ":analyticsId",
    component: withAsyncRouteLoading(() => {
      return Promise.all([
        import(/* webpackChunkName: "analytics-dashboard" */ "./components"),
      ]).then(([importedModule0]) => {
        const component = importedModule0.default;
        return component;
      });
      //.catch(err => {
      // throw err;
      // });
    }),
  };
};
